// @ts-nocheck
(function () {
  'use strict';

  /* ================================================================
     PART 1 — PRODUCT CARD INTERACTIONS
     (Same delegated-event logic as wear-collection.liquid inline JS)
     ================================================================ */

  function syncWearWishlistBtn(card, variantId) {
    var btn = card.querySelector('.wear-wishlist-btn');
    if (!btn) return;
    btn.setAttribute('data-variant-id', variantId);
    var sdk = window.WishListHero_SDK;
    if (!sdk || typeof sdk.GetWishListItems !== 'function') return;
    try {
      // Prefer the module's effective items (SDK cache + pending-ops ledger)
      // so a just-removed variant can't re-light the heart from a stale cache.
      var list =
        typeof WishlistManager !== 'undefined' && WishlistManager.getEffectiveItems
          ? WishlistManager.getEffectiveItems()
          : null;
      if (list === null) list = sdk.GetWishListItems();
      if (!Array.isArray(list)) list = [];
      var found = list.some(function (item) {
        return String(item.ProductVariantId) === String(variantId);
      });
      btn.classList.toggle('swym-added', found);
    } catch (_) {}
  }

  function updateSizes(card, productId, colorValue) {
    var variants = window.productVariants && window.productVariants[productId];
    if (!variants) return;

    var preorderMap = (window.productVariantPreorder && window.productVariantPreorder[productId]) || {};

    card.querySelectorAll('.size-btn').forEach(function (btn) {
      btn.classList.remove('selected');
      var size = btn.dataset.size;
      var matchedVariant = variants.find(function (v) {
        var options = [v.option1, v.option2, v.option3].filter(Boolean);
        return options.includes(colorValue) && options.includes(size) && v.available;
      });

      var badge = btn.querySelector('.size-btn__preorder-badge');

      if (matchedVariant) {
        btn.disabled = false;
        btn.style.textDecoration = 'none';
        btn.dataset.variantId = matchedVariant.id;

        // An available size flagged custom.preorder = true is purchasable as a
        // pre-order — show the PRE-ORDER badge on that size button.
        var isPreorderSize = preorderMap[matchedVariant.id] === true;
        btn.classList.toggle('is-preorder', isPreorderSize);
        if (badge) badge.hidden = !isPreorderSize;
      } else {
        btn.disabled = true;
        btn.style.textDecoration = 'line-through';
        btn.removeAttribute('data-variant-id');
        btn.classList.remove('is-preorder');
        if (badge) badge.hidden = true;
      }
    });
  }

  function openCartDrawer() {
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        // Update cart icon bubble count via section rendering
        var bubbleHTML = sections['cart-icon-bubble'];
        if (bubbleHTML) {
          var cartBubbleEl = document.getElementById('cart-icon-bubble');
          if (cartBubbleEl) {
            var tempBubble = document.createElement('div');
            tempBubble.innerHTML = bubbleHTML;
            var newBubbleContent = tempBubble.querySelector('.shopify-section');
            if (newBubbleContent) {
              cartBubbleEl.innerHTML = newBubbleContent.innerHTML;
            }
          }
        }

        var drawerHTML = sections['cart-drawer'];
        if (!drawerHTML) return;

        var temp = document.createElement('div');
        temp.innerHTML = drawerHTML;

        var newDrawer =
          temp.querySelector('cart-drawer') ||
          temp.querySelector('.cart-drawer') ||
          temp.querySelector('[data-cart-drawer]');

        var currentDrawer =
          document.querySelector('cart-drawer') ||
          document.querySelector('.cart-drawer') ||
          document.querySelector('[data-cart-drawer]');

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          // Re-attach overlay close listener lost when innerHTML was replaced
          var overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', currentDrawer.close.bind(currentDrawer));
          }
        }

        if (typeof currentDrawer?.open === 'function') {
          currentDrawer.open();
        } else if (currentDrawer) {
          currentDrawer.classList.add('active', 'open', 'is-visible');
          currentDrawer.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
        }
      });
  }

  function updateCartCount() {
    // Cart count is now updated via section rendering in openCartDrawer()
  }

  function addToCart(variantId, btn) {
    btn.classList.add('loading');
    document.body.classList.add('loading-cart');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('loading');
        document.body.classList.remove('loading-cart');
        // Notify ComplementaryController and other cart subscribers
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist-page' });
        }
        openCartDrawer();
      })
      .catch(function (err) {
        btn.classList.remove('loading');
        document.body.classList.remove('loading-cart');
        console.error(err);
      });
  }

  /* Quick add button click — notify-me / preorder mode */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick_add_btn');
    if (!btn) return;

    var mode = btn.dataset.mode;
    var notifyMode = btn.dataset.notify;

    if (mode !== 'notify-me' && notifyMode !== 'notify-me' && mode !== 'preorder') return;

    var card = btn.closest('.product_card');
    var notifyMeSection = card && card.querySelector('.notify-me-section');
    var notifyForm = notifyMeSection && notifyMeSection.querySelector('.notify-me-form');
    var quickAdd = card && card.querySelector('.quick_add');

    if (notifyMeSection && notifyForm) {
      notifyMeSection.classList.add('show');
      notifyForm.classList.add('show');
      notifyMeSection.style.display = 'block';
      notifyForm.style.display = 'flex';
      if (quickAdd) {
        quickAdd.classList.add('active');
        quickAdd.classList.add('active_force');
      }
    }
    e.preventDefault();
  });

  /* Close notify-me when clicking outside */
  document.addEventListener('click', function (e) {
    var clickedInQuickAdd = e.target.closest('.quick_add');
    var clickedInNotifyBtn = e.target.closest('.quick_add_btn[data-notify="notify-me"]');

    if (!clickedInQuickAdd && !clickedInNotifyBtn) {
      document.querySelectorAll('.notify-me-section.show').forEach(function (section) {
        var card = section.closest('.product_card');
        if (!card) return;
        var quickAdd = card.querySelector('.quick_add');
        var notifyForm = section.querySelector('.notify-me-form');

        section.classList.remove('show');
        if (notifyForm) {
          notifyForm.classList.remove('show');
          notifyForm.style.display = 'flex';
          notifyForm.reset();
        }
        if (quickAdd) {
          quickAdd.classList.remove('active');
          quickAdd.classList.remove('active_force');
        }
        section.querySelectorAll('.notify-success-msg').forEach(function (msg) { msg.remove(); });
      });
    }
  });

  /* Size click → add to cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.size-btn');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Immediate visual feedback — the add-to-cart request can be slow, so mark
    // the chosen size as selected the moment it's tapped.
    var sizesContainer = btn.closest('.sizes');
    if (sizesContainer) {
      sizesContainer.querySelectorAll('.size-btn.selected').forEach(function (el) {
        el.classList.remove('selected');
      });
    }
    btn.classList.add('selected');

    addToCart(variantId, btn);
  });

  /* Add to cart for products without sizes */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-tocart');
    if (!btn) return;

    if (btn.dataset.notify === 'notify-me') {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    addToCart(variantId, btn);
  });

  /* Color swatch click */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.swatch-item');
    if (!swatch) return;

    var card = swatch.closest('.product_card');
    if (!card) return;

    var mainImg = card.querySelector('.main-img');
    var hoverImg = card.querySelector('.hover-img');
    var mainImgMobile = card.querySelector('.main-img-mobile');
    var variantImage = swatch.dataset.variantImage;
    var variantHover = swatch.dataset.variantHover;
    var variantImageMobile = swatch.dataset.variantImageMobile;
    var settingsMainImage = mainImg && mainImg.dataset.settingsImage;
    var settingsHoverImage = hoverImg && hoverImg.dataset.settingsImage;
    var settingsMobileImage = mainImgMobile && mainImgMobile.dataset.settingsImage;

    if (mainImg) {
      if (variantImage) {
        mainImg.src = variantImage;
      } else if (mainImg.dataset.swappable !== 'false') {
        mainImg.src = settingsMainImage;
      }
    }

    if (mainImgMobile) {
      var mobileTarget = variantImageMobile || variantImage;
      if (mobileTarget) {
        mainImgMobile.src = mobileTarget;
      } else if (mainImgMobile.dataset.swappable !== 'false') {
        mainImgMobile.src = settingsMobileImage;
      }
    }

    if (hoverImg) {
      hoverImg.src = variantHover || settingsHoverImage;
      if (variantHover || settingsHoverImage) {
        hoverImg.style.display = 'block';
      }
    }

    // Link with ?variant= (not ?colour=) so Shopify renders the right colour
    // server-side. A named option param forces the PDP's client-side colour
    // correction, which hides the variant sections after first paint and
    // re-fetches — a visible blank/flash on navigation. Prefer an in-stock
    // variant of the colour so the PDP doesn't land on a sold-out size.
    var productLink = card.querySelector('.product-link');
    if (productLink) {
      var linkWrapper = swatch.closest('.wishlist-card-wrapper') || swatch.closest('.swiper-slide');
      var linkVariants =
        (linkWrapper && window.productVariants && window.productVariants[linkWrapper.dataset.productId]) || [];
      var linkColor = swatch.getAttribute('title');
      var colorMatches = linkVariants.filter(function (v) {
        return [v.option1, v.option2, v.option3].filter(Boolean).includes(linkColor);
      });
      var linkVariant =
        colorMatches.find(function (v) {
          return v.available;
        }) || colorMatches[0];
      var linkVariantId = (linkVariant && linkVariant.id) || swatch.dataset.variantId;
      productLink.href = linkVariantId
        ? productLink.dataset.baseUrl + '?variant=' + linkVariantId
        : productLink.dataset.baseUrl;
    }

    card.querySelectorAll('.swatch-item').forEach(function (el) { el.classList.remove('active'); });
    swatch.classList.add('active');

    if (swatch.dataset.variantId) syncWearWishlistBtn(card, swatch.dataset.variantId);

    var wrapper = swatch.closest('.wishlist-card-wrapper') || swatch.closest('.swiper-slide');
    if (wrapper) {
      var productId = wrapper.dataset.productId;
      var colorValue = swatch.getAttribute('title');
      var variants = (window.productVariants && window.productVariants[productId]) || [];

      var availableForColor = variants.some(function (v) {
        var options = [v.option1, v.option2, v.option3].filter(Boolean);
        return options.includes(colorValue) && v.available;
      });

      var quickAddDiv = card.querySelector('.quick_add');
      var sizesDiv = quickAddDiv && quickAddDiv.querySelector('.sizes');
      var notifyMeSection = quickAddDiv && quickAddDiv.querySelector('.notify-me-section');
      var quickAddHead = quickAddDiv && quickAddDiv.querySelector('.head');
      var quickAddBtn = card.querySelector('.quick_add_btn');
      var isPreorder = swatch.dataset.preorder === 'true';

      if (quickAddDiv) quickAddDiv.classList.remove('active_force');

      // Pre-order colours that still have a purchasable (continue-selling) size
      // fall through to the sizes branch so the shopper can pre-order a specific
      // size — updateSizes badges those sizes. Only colours with no available
      // size drop to the notify-me / PRE-ORDER-notify fallback below.
      if (!availableForColor) {
        if (sizesDiv) sizesDiv.style.display = 'none';
        if (quickAddHead) quickAddHead.style.display = 'none';
        if (notifyMeSection) {
          notifyMeSection.classList.add('show');
          var notifyForm = notifyMeSection.querySelector('.notify-me-form');
          var notifyEmail = notifyMeSection.querySelector('.notify-email');
          if (notifyForm) { notifyForm.style.display = 'flex'; notifyForm.classList.remove('show'); }
          if (notifyEmail) notifyEmail.value = '';
          notifyMeSection.querySelectorAll('.notify-success-msg').forEach(function (m) { m.remove(); });
        }
        if (quickAddBtn) {
          if (isPreorder) {
            quickAddBtn.textContent = 'PRE-ORDER';
            quickAddBtn.dataset.mode = 'preorder';
            quickAddBtn.removeAttribute('data-notify');
          } else {
            quickAddBtn.textContent = 'NOTIFY ME';
            quickAddBtn.dataset.notify = 'notify-me';
            quickAddBtn.removeAttribute('data-mode');
          }
        }
      } else {
        if (sizesDiv) sizesDiv.style.display = 'flex';
        if (quickAddHead) quickAddHead.style.display = 'flex';
        if (notifyMeSection) {
          notifyMeSection.classList.remove('show');
          var nf = notifyMeSection.querySelector('.notify-me-form');
          if (nf) nf.classList.remove('show');
          notifyMeSection.querySelectorAll('.notify-success-msg').forEach(function (m) { m.remove(); });
        }
        if (quickAddBtn) {
          quickAddBtn.textContent = 'QUICK ADD';
          quickAddBtn.dataset.mode = 'quick-add';
          quickAddBtn.removeAttribute('data-notify');
        }

        var addToCartBtn = card.querySelector('.add-tocart');
        if (addToCartBtn && swatch.dataset.variantId) {
          addToCartBtn.dataset.variantId = swatch.dataset.variantId;
        }

        if (productId) updateSizes(card, productId, colorValue);
      }
    }
  });

  /* Notify-me form submission */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.notify-me-form');
    if (!form) return;

    console.log('[wishlist notify] form submit fired');
    e.preventDefault();

    var email = form.querySelector('.notify-email').value.trim();
    var productId = form.dataset.productId;
    var productHandle = form.dataset.productHandle || '';
    var productTitle = form.dataset.productTitle || '';

    console.log('[wishlist notify] values:', { email: email, productId: productId, productHandle: productHandle, productTitle: productTitle });

    if (!email) {
      console.warn('[wishlist notify] email empty — aborting');
      alert('Please enter a valid email');
      return;
    }

    if (window.bodiskinBrevoBIS && typeof window.bodiskinBrevoBIS.submit === 'function') {
      console.log('[wishlist notify] calling window.bodiskinBrevoBIS.submit…');
      var p = window.bodiskinBrevoBIS.submit({
        email: email,
        source: 'back_in_stock',
        productId: productId,
        productHandle: productHandle,
        productTitle: productTitle,
        variantId: '',
      });
      if (p && typeof p.then === 'function') {
        p.then(function (ok) {
          console.log('[wishlist notify] submit resolved with:', ok);
        });
      }
    } else {
      console.warn('[wishlist notify] bodiskinBrevoBIS helper NOT loaded on window — email NOT sent to Brevo. Check that assets/brevo-bis.js is being served and that settings.enable_brevo_bis is on.');
    }

    form.style.display = 'none';
    var notifySection = form.closest('.notify-me-section');
    var wishlistSection = document.querySelector('#wishlist-main');
    var card = form.closest('.product_card');
    var quickAddBtn = card && card.querySelector('.quick_add_btn');
    var isPreorder = quickAddBtn && quickAddBtn.dataset.mode === 'preorder';

    var defaultMessage = isPreorder
      ? 'Thank you! Your pre-order has been recorded.'
      : "Thank you! We'll notify you when this is available.";
    var notifyText = isPreorder
      ? (wishlistSection && wishlistSection.dataset.preorderText || defaultMessage)
      : (wishlistSection && wishlistSection.dataset.notifyText || defaultMessage);

    if (notifySection) {
      var successDiv = document.createElement('div');
      successDiv.className = 'notify-success-msg';
      var successMsg = document.createElement('p');
      successMsg.textContent = notifyText;
      successDiv.appendChild(successMsg);
      notifySection.appendChild(successDiv);
    }
  });

  /* Product link click — navigate with selected variant */
  document.addEventListener('click', function (e) {
    var productLink = e.target.closest('.product-link');
    if (!productLink) return;
    window.location.href = productLink.href;
    e.preventDefault();
  });

  /* ================================================================
     PART 2 — WISHLIST PAGE: FETCH & RENDER
     ================================================================ */

  function getHandleFromUrl(url) {
    try {
      /* Shared-list URLs come from the app and are absolute; wishlist SDK ones
         can be root-relative — the base makes both parse. */
      var path = new URL(url, window.location.origin).pathname;
      var parts = path.replace(/\/$/, '').split('/');
      return parts[parts.length - 1];
    } catch (_) {
      return null;
    }
  }

  function runInlineScripts(wrapper) {
    wrapper.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      newScript.textContent = oldScript.textContent;
      document.head.appendChild(newScript);
      document.head.removeChild(newScript);
    });
  }

  function initProductCard(card) {
    var mainImg = card.querySelector('.main-img');
    var hoverImg = card.querySelector('.hover-img');
    var mainImgMobile = card.querySelector('.main-img-mobile');

    if (mainImg) mainImg.dataset.settingsImage = mainImg.src;
    if (hoverImg) hoverImg.dataset.settingsImage = hoverImg.src;
    if (mainImgMobile) mainImgMobile.dataset.settingsImage = mainImgMobile.src;

    var preselectedColor = card.dataset.preselectColor;
    var targetSwatch = null;

    if (preselectedColor) {
      targetSwatch = card.querySelector('.swatch-item[title="' + preselectedColor + '"]');
    }
    if (!targetSwatch) {
      targetSwatch = card.querySelector('.swatch-item:not(.visually-disabled)');
    }
    if (!targetSwatch) {
      targetSwatch = card.querySelector('.swatch-item');
    }

    if (targetSwatch) {
      if (mainImg && mainImg.src && !targetSwatch.dataset.variantImage) {
        targetSwatch.dataset.variantImage = mainImg.src;
      }
      if (hoverImg && hoverImg.src && !targetSwatch.dataset.variantHover) {
        targetSwatch.dataset.variantHover = hoverImg.src;
      }
      if (mainImgMobile && mainImgMobile.src && !targetSwatch.dataset.variantImageMobile) {
        targetSwatch.dataset.variantImageMobile = mainImgMobile.src;
      }
      targetSwatch.click();
    }
    // The swatch click above already sets the correct quick-add state: QUICK ADD
    // (with per-size PRE-ORDER badges) when the colour has an available size, or
    // the PRE-ORDER / NOTIFY-ME fallback when it doesn't.
  }

  /* Remove-from-wishlist button */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-remove-btn');
    if (!btn) return;

    var variantId = parseInt(btn.dataset.variantId, 10);
    var cardWrapper = btn.closest('.wishlist-card-wrapper');

    if (typeof WishlistManager === 'undefined') return;

    WishlistManager.removeFromWishlist({ epi: variantId })
      .then(function () {
        if (cardWrapper) {
          cardWrapper.classList.add('removing');
          setTimeout(function () { cardWrapper.remove(); }, 300);
        }
      })
      .catch(function () {});
  });

  function sortGrid(sortValue) {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var wrappers = Array.from(grid.querySelectorAll('.wishlist-card-wrapper'));
    wrappers.sort(function (a, b) {
      switch (sortValue) {
        case 'price-asc':
          return parseInt(a.dataset.priceRaw, 10) - parseInt(b.dataset.priceRaw, 10);
        case 'price-desc':
          return parseInt(b.dataset.priceRaw, 10) - parseInt(a.dataset.priceRaw, 10);
        case 'name-asc':
          return (a.dataset.sortTitle || '').localeCompare(b.dataset.sortTitle || '');
        case 'name-desc':
          return (b.dataset.sortTitle || '').localeCompare(a.dataset.sortTitle || '');
        default:
          return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10);
      }
    });
    wrappers.forEach(function (w) { grid.appendChild(w); });
  }

  function initControls() {
    var sortSelect = document.getElementById('wishlist-sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortGrid(this.value);
      });
    }

    var viewGrid = document.getElementById('wishlist-grid');
    var threeBtn = document.querySelector('.three-list');
    var twoBtn = document.querySelector('.two-list');
    var oneBtn = document.querySelector('.one-list');

    if (!viewGrid || !threeBtn || !twoBtn) return;

    function setView(col) {
      viewGrid.classList.remove('wishlist-grid--1col', 'wishlist-grid--2col', 'wishlist-grid--3col');
      if (oneBtn) oneBtn.classList.remove('active');
      twoBtn.classList.remove('active');
      threeBtn.classList.remove('active');
      if (col === 1) {
        viewGrid.classList.add('wishlist-grid--1col');
        if (oneBtn) oneBtn.classList.add('active');
      } else if (col === 2) {
        viewGrid.classList.add('wishlist-grid--2col');
        twoBtn.classList.add('active');
      } else {
        viewGrid.classList.add('wishlist-grid--3col');
        threeBtn.classList.add('active');
      }
    }

    if (oneBtn) {
      oneBtn.addEventListener('click', function () { setView(1); });
    }
    twoBtn.addEventListener('click', function () { setView(2); });
    threeBtn.addEventListener('click', function () { setView(3); });

    if (window.innerWidth <= 767) {
      setView(1);
    } else if (threeBtn.classList.contains('active')) {
      setView(3);
    } else {
      setView(2);
    }
  }

  /* opts.readOnly — skip the remove-from-wishlist heart. Used by the shared-list
     page (wishlist-shared.js): the viewer is looking at someone else's list and
     has no business mutating it. */
  function renderWishlistItem(swymItem, index, opts) {
    var options = opts || {};
    var productUrl = swymItem.du;
    var variantId = swymItem.epi;
    var handle = getHandleFromUrl(productUrl);
    if (!handle) return Promise.resolve(null);

    var fetchUrl = '/products/' + encodeURIComponent(handle) +
      '?view=wishlist-product' +
      (variantId ? '&variant=' + variantId : '');

    return fetch(fetchUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to fetch card for ' + handle);
        return res.text();
      })
      .then(function (html) {
        var wrapper = document.createElement('div');
        wrapper.className = 'wishlist-card-wrapper';
        wrapper.dataset.productId = '';
        wrapper.innerHTML = html;

        /* Run productVariants scripts */
        runInlineScripts(wrapper);

        /* Attach product id to wrapper for swatch events */
        var card = wrapper.querySelector('.product_card');
        if (card) {
          wrapper.dataset.priceRaw = card.dataset.price || '0';
          wrapper.dataset.sortTitle = (card.dataset.title || '').toLowerCase();
          wrapper.dataset.index = index != null ? index : 0;
        }

        if (card && !options.readOnly) {
          /* Inject remove button */
          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'wishlist-remove-btn';
          removeBtn.setAttribute('aria-label', 'Remove from wishlist');
          removeBtn.dataset.variantId = variantId;
          removeBtn.dataset.productUrl = productUrl;
          var heartTemplate = document.getElementById('wishlist-heart-icon');
          if (heartTemplate) {
            removeBtn.appendChild(heartTemplate.content.cloneNode(true));
          } else {
            removeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 46 39"><path stroke="#fff" stroke-width="2" d="M45 12a10.88 10.88 0 0 1-3.202 7.768l-17.69 17.773a1.56 1.56 0 0 1-2.213 0L4.204 19.768A10.95 10.95 0 0 1 1 11.992c0-2.94 1.138-5.7 3.204-7.776A10.85 10.85 0 0 1 11.943 1c2.926 0 5.675 1.143 7.74 3.218l3.318 3.333 3.317-3.333A10.85 10.85 0 0 1 34.058 1c2.925 0 5.674 1.143 7.74 3.218A10.88 10.88 0 0 1 45 12Z"/></svg>';
          }

          var imgWrap = card.querySelector('.img_wrap');
          var imageContainer = card.querySelector('.image-container');
          if (imageContainer) {
            imageContainer.style.position = 'relative';
            imageContainer.appendChild(removeBtn);
          } else if (imgWrap) {
            imgWrap.appendChild(removeBtn);
          }
        }

        /* Set product-id on wrapper so swatch handler can find it */
        var variantsScript = Object.keys(window.productVariants || {});
        if (variantsScript.length) {
          wrapper.dataset.productId = variantsScript[variantsScript.length - 1];
        }

        return wrapper;
      })
      .catch(function (err) {
        console.warn('[wishlist-page] ' + err.message);
        return null;
      });
  }

  /* Resolve once the card's *visible* product image (post variant swap) has
     finished loading or errored, so a card never fades in half-painted. */
  function cardImageReady(wrapper) {
    var isMobile = window.matchMedia('(max-width: 767.98px)').matches;
    var img = wrapper.querySelector(isMobile ? '.main-img-mobile' : '.main-img');
    if (!img || !img.getAttribute('src')) return Promise.resolve();
    if (img.complete && img.naturalWidth > 0) return Promise.resolve();
    return new Promise(function (resolve) {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  }

  /* Fade the fully-built cards in with a short stagger. The spinner stays up
     until the same frame the reveal starts, so there's no blank gap between
     "loading" and "content". A slow CDN image can't hold the page hostage —
     reveal is forced after 1.5s regardless. */
  function revealCards(wrappers, loadingEl) {
    var imagesReady = Promise.all(wrappers.map(cardImageReady));
    var deadline = new Promise(function (resolve) { setTimeout(resolve, 1500); });

    Promise.race([imagesReady, deadline]).then(function () {
      // Double rAF guarantees the opacity:0 state was painted at least once,
      // so the transition always runs instead of snapping.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (loadingEl) loadingEl.style.display = 'none';
          var maxDelay = 0;
          wrappers.forEach(function (wrapper, i) {
            var delay = Math.min(i * 60, 420);
            maxDelay = delay > maxDelay ? delay : maxDelay;
            wrapper.style.transitionDelay = delay + 'ms';
            wrapper.classList.add('is-ready');
          });
          // Drop the stagger delays once the entrance finishes so later
          // opacity transitions (e.g. the .removing fade-out) fire instantly.
          setTimeout(function () {
            wrappers.forEach(function (wrapper) { wrapper.style.transitionDelay = ''; });
          }, maxDelay + 600);
        });
      });
    });
  }

  /* Reusable pieces for the shared-list page (wishlist-shared.js), which builds
     its own grid from the Wishlist Hero app-proxy markup instead of the SDK. */
  window.WishlistPage = {
    renderItem: renderWishlistItem,
    initProductCard: initProductCard,
    revealCards: revealCards,
    initControls: initControls,
    sortGrid: sortGrid,
  };

  function initWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    var loadingEl = document.getElementById('wishlist-loading');
    var emptyEl = document.getElementById('wishlist-empty');

    if (!grid) return;
    /* Shared-list page owns its own render pass — the SDK holds the *viewer's*
       wishlist, which is not the list they came here to see. */
    if (document.documentElement.classList.contains('wishlist-shared-page')) return;

    function renderWishlist(sdk) {
      // Prefer the module's effective items (SDK cache + pending-ops ledger):
      // the app embed's page-load GET can overwrite its cache with a
      // pre-mutation snapshot, which would render ghost cards for items the
      // customer already removed (or drop ones they just added).
      var items =
        typeof WishlistManager !== 'undefined' && WishlistManager.getEffectiveItems
          ? WishlistManager.getEffectiveItems()
          : null;
      if (items === null) {
        try {
          items = sdk.GetWishListItems();
        } catch (_) {
          items = [];
        }
      }
      var list = Array.isArray(items) ? items : [];

      /* Normalize Wishlist Hero items to the shape renderWishlistItem expects (du + epi) */
      var normalized = list.map(function (item) {
        return {
          du: item.ProductLink,
          epi: item.ProductVariantId,
        };
      });

      if (!normalized.length) {
        if (loadingEl) loadingEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }

      Promise.all(normalized.map(function (item, index) { return renderWishlistItem(item, index); }))
        .then(function (wrappers) {
          var valid = wrappers.filter(Boolean);

          if (!valid.length) {
            if (loadingEl) loadingEl.style.display = 'none';
            if (emptyEl) emptyEl.style.display = 'block';
            return;
          }

          // Cards enter the DOM at opacity 0 (see .wishlist-card-wrapper in
          // wishlist-page.css), so the variant-image swap and quick-add
          // rewiring done by initProductCard happen while they're invisible —
          // the customer never sees the card rebuild itself.
          valid.forEach(function (wrapper) {
            grid.appendChild(wrapper);
            var card = wrapper.querySelector('.product_card');
            if (card) initProductCard(card);
          });

          revealCards(valid, loadingEl);
        });
    }

    function whenSdkReady(callback) {
      if (window.WishListHero_SDK) {
        callback(window.WishListHero_SDK);
        return;
      }
      var fired = false;
      function fire() {
        if (fired) return;
        if (!window.WishListHero_SDK) return;
        fired = true;
        callback(window.WishListHero_SDK);
      }
      document.addEventListener('wishlist-hero-wishlist-sdk-ready', fire);
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (window.WishListHero_SDK) {
          clearInterval(poll);
          fire();
        } else if (attempts >= 30) {
          clearInterval(poll);
          if (loadingEl) loadingEl.style.display = 'none';
          if (emptyEl) emptyEl.style.display = 'block';
        }
      }, 500);
    }

    whenSdkReady(renderWishlist);

    initControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }
})();
